import {EntityService} from '../EntityService';

export class TypeInvoiceService extends EntityService {

  static entity = 'app/type-invoice';

}
